
import { useEffect } from 'react'
import Select from 'react-select'
import { EnergyStatusDDLAPI, UnitTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPUnitTypeDDL = (props) => {
    const { UnitType, setUnitType, rowData, Flag,IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            Flag: Flag,
        }
        dispatch(UnitTypeDDLAPI({ data }))
    }, [IsPost])

    const { UnitTypeData } = useSelector(state => state.UnitTypeDDL)

    useEffect(() => {
        handleSTPUnitTypeDDL()
    }, [UnitTypeData])

    const handleSTPUnitTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (UnitTypeData && UnitTypeData.table && UnitTypeData.table.length > 0) {
            let list = UnitTypeData.table.map((item, index) => ({
                value: item.m_stP_UnitTypeID,
                label: item.unitType,
            }))
            setUnitType({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_stP_UnitTypeID : 0,
                Label: Flag === 'Update' ? rowData.unitType : "Select...",
            })
        }
        else {
            setUnitType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Unit Type </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: UnitType.ID, label: UnitType.Label }}
                onChange={(e) => {
                    e ?
                        setUnitType({ ...UnitType, ID: e.value, Label: e.label })
                        :
                        setUnitType({ ...UnitType, ID: 0, Label: "Select..." })

                }}
                options={UnitType.DDL}
            />
        </div>
    )
}